<template>
  <div
    :id="data.Id"
    :data-elementindex="getElementIndex"
    :style="getStyles"
    :data-translateX="data.X"
    :data-translateY="data.Y"
    :data-rotate="data.RotateDegree"
    :contenteditable="isEditable"
    :class="getClass"
    data-isselect="0"
    data-type="text"
  >

    <div
      :style="[getStylesFocusTextDiv]"
      :id="'editor-'+data.Id"
      class="focus-text-div outline-text"
      @keyup.stop="updateTheTextValue">
      <div v-html="getHtml"/>
    </div>
    <svg v-if="data.outLine.textEffect != 'none'" xmlns="http://www.w3.org/2000/svg" style="width: 0px!important; height: 0px!important;">
      <filter :id="getFilterId">
        <feMorphology in="SourceAlpha" result="Dilated" operator="dilate" :radius="getOutlineStrokeWidth"></feMorphology>
        <feFlood :flood-color="data.outLine.strokeColor" result="OutlineColor"></feFlood>
        <feComposite in="OutlineColor" in2="Dilated" operator="in" result="Outline"></feComposite>
        <feMerge>
          <feMergeNode in="Outline" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </svg>

  </div>
</template>
<script>
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

export default {
  name:  'TextComponent',
  props: {
    data:                 Object,
    elementIndex:         Number,
    isRenderingPagePanel: Boolean,
    isFakeRendering:      { type: Boolean, default: false },
    isAnimationInProgress: {
      type:    Boolean,
      default: false,
    }
  },
  data() {
    return {
      editor:     null,
      isEditable: false,
    };
  },
  computed: {
    getFilterId() {
      return this.isAnimationInProgress ? `filter-anim-${this.data.Id}` :`filter-${this.data.Id}`;
    },
    getOutlineStrokeWidth() {
      const fontsize = parseInt(this.data.fontSize);
      return this.data.outLine.strokeWidth * (fontsize/20);
    },
    getElementIndex() {
      return this.data.elementIndex;
    },
    getStylesFocusTextDiv() {
      const {
        lineSpacing, fontFamily,
        fontSize, color, IsVisible, isBold, isItalic, isUnderline,
      } = this.data;

      return {
        fontSize:       (typeof fontSize === 'string' && fontSize.endsWith('px')) ? fontSize : `${fontSize}px`,
        lineHeight:     lineSpacing,
        color,
        fontFamily:     "'" + `${this.data.fontFamily}` + "'",
        width:          '100%',
        height:         'auto !important',
        visibility:     IsVisible ? 'visible' : 'hidden',
        fontWeight:     isBold ? 'bold' : 'normal',
        fontStyle:      isItalic ? 'italic' : 'normal',
        textDecoration: isUnderline ? 'underline' : 'none',
        // alignItems:this.getVerticalAlign,
        textAlign:      this.getHorizontalAlign,
        overflowWrap:   'break-word',
        padding:        '0px 0px',
        filter: this.isAnimationInProgress ? `url(#filter-anim-${this.data.Id})` :`url(#filter-${this.data.Id})`
      };
    },
    getStylesFocusTextDiv1() {
      const {
        lineSpacing, fontFamily,
        fontSize, color, IsVisible, isBold, isItalic, isUnderline,
      } = this.data;

      return {
        fontSize:       (typeof fontSize === 'string' && fontSize.endsWith('px')) ? fontSize : `${fontSize}px`,
        lineHeight:     lineSpacing,
        color,
        fontFamily:     "'" + `${this.data.fontFamily}` + "'",
        width:          '100%',
        height:         'auto !important',
        visibility:     IsVisible ? 'visible' : 'hidden',
        fontWeight:     isBold ? 'bold' : 'normal',
        fontStyle:      isItalic ? 'italic' : 'normal',
        textDecoration: isUnderline ? 'underline' : 'none',
        // alignItems:this.getVerticalAlign,
        textAlign:      this.getHorizontalAlign,
        overflowWrap:   'break-word',
        padding:        '0px 0px',
        '-webkit-text-stroke-color': this.data.outLine.strokeColor,
        '-webkit-text-stroke-width': this.data.outLine.strokeWidth + 'px',
      };
    },
    getStyles() {
      const {
        X, Y, RotateDegree, scaleX, scaleY, Width, Height, PdfSortOrder, IsVisible, isEditorEnable,
      } = this.data;
      const stroke = this.data.outLine.strokeWidth + 'px';

      return {
        transform:  `rotate(${RotateDegree}deg) scale(${scaleX},${scaleY})`,
        zIndex:     PdfSortOrder,
        width:      `${Width}px`,
        left:       `${X}px`,
        top:        `${Y}px`,
        height:     `${Height}px`,
        visibility: IsVisible ? 'visible' : 'hidden',
        cursor:     isEditorEnable ? 'text' : '',
        display:    'flex',
        alignItems: this.getVerticalAlign,
        overflowY:  'initial',
        textShadow: this.data.textShadow.textEffect === 'shadow' ? `${this.data.textShadow.shadowOffsetX}px ${this.data.textShadow.shadowOffsetY}px ${this.data.textShadow.shadowBlur}px ${this.data.textShadow.shadowColor}` : '',
        // transformOrigin: 'top left',
        //'--stroke-width': stroke,
        //'--stroke-color': this.data.outLine.strokeColor,
      };
    },
    getClass() {
      const classes = 'position-absolute text-object';
      return this.data.locked ? `${classes} untarget` : `${classes} target`;
    },
    getHtml() {
      return typeof this.data.Value === 'string' ? this.data.Value : this.data.Value.firstElementChild.outerHTML;
    },
    getVerticalAlign() {
      const verticalAlign = this.data.verticalAlign.toLowerCase();
      if (verticalAlign == 'middle') { return 'center'; }
      if (verticalAlign == 'top') { return 'flex-start'; }
      if (verticalAlign == 'bottom') { return 'flex-end'; }

      return 'flex-start';
    },
    getHorizontalAlign() {
      if (this.data.isJustifyCenter) { return 'center'; }
      if (this.data.isJustifyLeft) { return 'left'; }
      if (this.data.isJustifyRight) { return 'right'; }
      if (this.data.isJustify) { return 'justify'; }
    },
    outlineStyles() {
      const stroke = this.strokeWidth + 'px';
      return {
        '--stroke-width': stroke,
        '--stroke-color': this.strokeColor,
      };
    },
  },
  mounted() {
    if (!this.isFakeRendering) {
      const text                   = document.getElementById(this.data.Id).firstElementChild;
      const focusTextDivFirstChild = text.firstElementChild;
      try {
        if ((focusTextDivFirstChild.clientHeight > this.data.Height) && (this.data.isTextAdjustmentsNeeded)) {
          this.makeTextAdjustments(focusTextDivFirstChild);
        }
      } catch (e) {
        console.log(e.message);
      } finally {
        text.style.width = 'inherit';
      }
    }
  },
  methods: {
    updateTheTextValue() {
      EventBus.$emit(ApplicationEventTypes.TextObjectEvents.TEXT_SELECTION_UPDATED, this.getTextSelectionProperties);
    },
    makeTextAdjustments(element) {
      const allSpans = element.querySelectorAll('span, font, div, ul'); // only get those element that contain attr fontsize
      const max      = this.findMaxFont(allSpans);
      if (!allSpans.length || max === 1) { return; }
      let count = 0;
      while (element.clientHeight > this.data.Height && count < 100) {
        this.decreaseFontSize(allSpans, max, element);
        count += 1;
      }
      EventBus.$emit('UpdateTextObjectValue', { value: element.outerHTML, index: this.getElementIndex }); // TODO:It update the value when text adjust the container
    },
    decreaseFontSize(allSpans, max, element) {
      for (let i = 0; i < allSpans.length; i++) {
        if (allSpans[i].style.fontSize === '' && allSpans[i].tagName === 'DIV') { continue; }


        if (allSpans[i].style.fontSize === '') {
          allSpans[i].style.fontSize = this.getComputedFontStyle(allSpans[i]);
        }

        if (element.clientHeight <= this.data.Height) {
          break;
        }

        if (allSpans[i].tagName === 'UL') {
          this.updateULFontSize(allSpans[i], max);
        } else {
          const fontSize = parseInt(parseFloat(allSpans[i].style.fontSize) - parseFloat(allSpans[i].style.fontSize) / max, 10);
          if (fontSize > 4) { allSpans[i].style.fontSize = `${fontSize}px`; }
        }
      }
    },
    findMaxFont(allSpans) {
      let maxFontSize = 1;
      for (let i = 0; i < allSpans.length; i++) {
        allSpans[i].style.fontSize === '' && (allSpans[i].style.fontSize = this.getComputedFontStyle(allSpans[i]));
        parseFloat(allSpans[i].style.fontSize) > maxFontSize && (maxFontSize = parseFloat(allSpans[i].style.fontSize));
      }
      return maxFontSize;
    },
    updateULFontSize(ul, max) {
      const listElements = [...ul.children].filter(elm => elm.matches('li'));
      for (let listIter = 0; listIter < listElements.length; listIter += 1) {
        if (listElements[listIter].style.fontSize === '') {
          listElements[listIter].style.fontSize = this.getComputedFontStyle(listElements[listIter]);
          const fontSize                        = parseInt(parseFloat(listElements[listIter].style.fontSize) - parseFloat(listElements[listIter].style.fontSize) / max, 10);
          console.log('changing font to ', fontSize);
          if (fontSize > 4) { listElements[listIter].style.fontSize = `${fontSize}px`; }
        }
      }
    },
    getComputedFontStyle(element) {
      return window.getComputedStyle(element, null).getPropertyValue('font-size');
    },
  },
};
</script>
<style lang="scss">
  .focus-text-editor{
    outline: dashed 2px gray;
    outline-offset: 5px;
  }

  .focus-text-div{
    width: inherit !important;
    height: 100% !important;
    ul, ol{
      padding: 0px;
    }
    li{
      margin-left: calc(1.7*1em);
      padding-left: 5px;
    }
    .li-center-align{
      list-style-position: inside;
      margin-left: 0px;
      margin-right:0px;
    }
    .li-right-align{
      list-style-position: inside;
      margin-left: 0px;
    }
  }
  .parent-font-inherit{
    font-family: inherit;
  }

  .outline-text {
    text-shadow:
        calc(var(--stroke-width) * 1) calc(var(--stroke-width) * 0) 0 var(--stroke-color),
        calc(var(--stroke-width) * 0.9239) calc(var(--stroke-width) * 0.3827) 0 var(--stroke-color),
        calc(var(--stroke-width) * 0.7071) calc(var(--stroke-width) * 0.7071) 0 var(--stroke-color),
        calc(var(--stroke-width) * 0.3827) calc(var(--stroke-width) * 0.9239) 0 var(--stroke-color),
        calc(var(--stroke-width) * 0) calc(var(--stroke-width) * 1) 0 var(--stroke-color),
        calc(var(--stroke-width) * -0.3827) calc(var(--stroke-width) * 0.9239) 0 var(--stroke-color),
        calc(var(--stroke-width) * -0.7071) calc(var(--stroke-width) * 0.7071) 0 var(--stroke-color),
        calc(var(--stroke-width) * -0.9239) calc(var(--stroke-width) * 0.3827) 0 var(--stroke-color),
        calc(var(--stroke-width) * -1) calc(var(--stroke-width) * 0) 0 var(--stroke-color),
        calc(var(--stroke-width) * -0.9239) calc(var(--stroke-width) * -0.3827) 0 var(--stroke-color),
        calc(var(--stroke-width) * -0.7071) calc(var(--stroke-width) * -0.7071) 0 var(--stroke-color),
        calc(var(--stroke-width) * -0.3827) calc(var(--stroke-width) * -0.9239) 0 var(--stroke-color),
        calc(var(--stroke-width) * 0) calc(var(--stroke-width) * -1) 0 var(--stroke-color),
        calc(var(--stroke-width) * 0.3827) calc(var(--stroke-width) * -0.9239) 0 var(--stroke-color),
        calc(var(--stroke-width) * 0.7071) calc(var(--stroke-width) * -0.7071) 0 var(--stroke-color),
        calc(var(--stroke-width) * 0.9239) calc(var(--stroke-width) * -0.3827) 0 var(--stroke-color);
  }

</style>
